import type { HelpAssistantPanelAction } from './actions';
import { reducer } from './reducer';
import { createInitialHelpAssistantPanelState } from './types';
import type { HelpAssistantPanelState, HelpAssistantPanelStateInit } from './types';
import { computed, createModel, signal } from '@preact/signals-react';

export const HelpAssistantPanelStateModel = createModel((init: HelpAssistantPanelStateInit = {}) => {
    const state = signal<HelpAssistantPanelState>(createInitialHelpAssistantPanelState(init));

    const isOpen = computed(() => state.value.isOpen);
    const activeMode = computed(() => state.value.activeMode);
    const isHelpOpen = computed(() => state.value.isOpen && state.value.activeMode === 'help');
    const isAssistantOpen = computed(() => state.value.isOpen && state.value.activeMode === 'assistant');
    const location = computed(() => state.value.helpLocation);
    const hoveredStepIndex = computed(() => state.value.hoveredStepIndex);
    const guideCompact = computed(() => state.value.guideCompact);
    const panelWidth = computed(() => state.value.panelWidth);

    return {
        state,
        isOpen,
        activeMode,
        isHelpOpen,
        isAssistantOpen,
        location,
        hoveredStepIndex,
        guideCompact,
        panelWidth,
        dispatch(action: HelpAssistantPanelAction): HelpAssistantPanelState {
            const next = reducer(state.value, action);
            state.value = next;
            return next;
        },
    };
});

export type HelpAssistantPanelStateModel = InstanceType<typeof HelpAssistantPanelStateModel>;
